import * as React from 'react';
import { deepEquals } from 'app/infrastructure/js';
import { getEntityTypeFromStorePath } from 'app/infrastructure/store/entity';
import styles from './loss-potential-evaluation.scss';
import { TileProps } from 'ui/tile/tile';
import { CodeTitleTile } from 'app/components/code-title-tile';

export interface LossPotentialEvaluationProps extends TileProps {
  lastChild: boolean;
}

export class LossPotentialEvaluation extends React.PureComponent<LossPotentialEvaluationProps, any> {

  private hasActiveSibling() {
    const { resolveContext } = (this.props as any);
    const { activeChildItem } = (this.props as any).hostProps();

    if (activeChildItem && activeChildItem.length > 1) {

      // Select those path elements that might be shared for later comparison.
      const partialPath = activeChildItem.slice(0, resolveContext.path.length);

      const activeType = getEntityTypeFromStorePath(partialPath);
      const thisType = getEntityTypeFromStorePath(resolveContext.path);

      return activeType === thisType && !deepEquals(partialPath, resolveContext.path);
    }

    return false;
  }

  private hasActiveDescendant() {
    const { resolveContext } = (this.props as any);
    const { activeChildItem } = (this.props as any).hostProps();

    if (activeChildItem) {
      const partialPath = activeChildItem.slice(0, resolveContext.path.length);
      return deepEquals(resolveContext.path, partialPath);
    }

    return false;
  }

  public render() {
    const { activate, lastChild, label, primaryKey } = this.props;
    const { evaluation } = styles;

    // There are two main cases where this should render itself.
    const isActiveChildOrHasActiveDescendent = activate || this.hasActiveDescendant();
    const isLastChildAndDoesntHaveActiveSibling = lastChild && !this.hasActiveSibling();

    if (!isActiveChildOrHasActiveDescendent && !isLastChildAndDoesntHaveActiveSibling) {
      return null;
    }

    const primaryKeyAsCode = primaryKey && { description: `${label.text} ${primaryKey.value}`, value: primaryKey.value };

    return (
      <CodeTitleTile
        {...this.props} primaryKey={primaryKeyAsCode} className={`losspotentialtile ${evaluation}`}
      />
    );
  }
}
